import { configureStore } from "@reduxjs/toolkit";
import accountReducer from "src/redux/account-slice";
import balanceReducer from "src/redux/balance-slice";
import battleHandReducer from "src/redux/battle-hand-slice";
import boxSaleReducer from "src/redux/box-sale-slice";
import bridgeReducer from "src/redux/bridge-slice";
import chestReducer from "src/redux/chest-slice";
import classicFarmingReducer from "src/redux/classic-farming";
import configReducer from "src/redux/config-slice";
import dexReducer from "src/redux/dex-slice";
import expeditionReducer from "src/redux/expedition-slice";
import heuristicFarmingReducer from "src/redux/heuristic-farming";
import inventory2Reducer from "src/redux/inventory2-slice";
import nftMarketReducer from "src/redux/nft-market-slice";
import priceReducer from "src/redux/price-slice";
import profileReducer from "src/redux/profile-slice";
import themeReducer from "src/redux/theme-slice";
import ticketReducer from "src/redux/ticket-slice";
import treasureMapReducer from "src/redux/treasure-map-slice";
import txStatusReducer from "src/redux/tx-status-slice";
import dilutionStakingReducer from "./dilution-staking-slice";

export default configureStore({
  reducer: {
    configSlice: configReducer,
    priceSlice: priceReducer,
    accountSlice: accountReducer,
    themeSlice: themeReducer,
    balanceSlice: balanceReducer,
    nftMarketSlice: nftMarketReducer,
    profileSlice: profileReducer,
    chestSlice: chestReducer,
    inventory2Slice: inventory2Reducer,
    classicFarmingSlice: classicFarmingReducer,
    expeditionSlice: expeditionReducer,
    heuristicFarmingSlice: heuristicFarmingReducer,
    battleHandSlice: battleHandReducer,
    ticketSlice: ticketReducer,
    treasureMapSlice: treasureMapReducer,
    txStatusSlice: txStatusReducer,
    boxSaleSlice: boxSaleReducer,
    bridgeSlice: bridgeReducer,
    dexSlice: dexReducer,
    dilutionStaking: dilutionStakingReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NODE_ENV === "development",
});
